export const getCurrentPageUrl = (): string => {
  const { origin, pathname, search, hash } = window.location;
  const url = `${origin}${pathname}${search}${hash}`;
  console.log("Current Page URL:", url);
  return url;
};